function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#BAD8E6",
  d: "M7.885 5.548c1.373 0 2.453.152 2.73.558 1.425 1.882-8.609 13.69-9.445 13.332C.5 19.26 6.52 11.743 5.516 8.7 5.016 7.09 0 7.27 0 6.732c0-.375 4.72-1.184 7.885-1.184zM9.28 0c1.285 0 2.326.973 2.326 2.173 0 1.2-1.04 2.173-2.326 2.173s-2.326-.972-2.326-2.173C6.953.973 7.993 0 9.279 0z",
  transform: "translate(-112.000000, -663.000000) translate(112.000000, 663.000000)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009FE4",
  d: "M9.645 7.308c1.373 0 2.453.152 2.73.558C13.8 9.748 3.766 21.556 2.93 21.198c-.67-.179 5.35-7.695 4.346-10.738-.5-1.61-5.516-1.43-5.516-1.968 0-.375 4.72-1.184 7.885-1.184zM11.04 1.76c1.285 0 2.326.973 2.326 2.173 0 1.2-1.04 2.173-2.326 2.173s-2.326-.972-2.326-2.173c0-1.2 1.04-2.173 2.326-2.173z",
  transform: "translate(-112.000000, -663.000000) translate(112.000000, 663.000000)"
}))));

function SvgWalletIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.3a596d22.svg";
export { ForwardRef as ReactComponent };